module.exports = __webpack_public_path__ + "img/olimpija-logo-icon.3039dbef.png";